import React from "react"
import styled from "react-emotion"
import { Link } from 'react-router'

import { Section } from "ui"
import Card from "ui/components/Card"
import Text from "ui/components/Text"

import { ContentWrapper, Content } from "features/studio/ui/Layout"
import { withRouter } from "react-router"

class NotFoundPage extends React.Component {
    state = {}

    render() {
        return (
            <ContentWrapper>
                <Content>
                    <LoginPanel>
                        <Logo src="/static/media/stacker-logo.32813f5d.png" alt="Stacker Logo" />
                        <Section margin="small">
                            <Text size="large">Page Not Found</Text>

                            <Text size="medium"><Link to="/">Return to Stacker Studio</Link></Text>
                        </Section>
                    </LoginPanel>
                </Content>
            </ContentWrapper>
        )
    }
}

export default withRouter(NotFoundPage)

const LoginPanel = styled(Card)`
    width: 100%;
    max-width: 800px;
    height: 600px;
    text-align: center;
    margin: 10% auto;
    padding: 10%;
    align-items: center;
`

const Logo = styled("img")`
    width: 100%;
    max-width: 300px;
    display: block;
    margin: 0px auto ${props => props.theme.xlarge};
`



// WEBPACK FOOTER //
// ./src/app/NotFoundPage.js